export default __webpack_public_path__ + "static/andrzej_piotrowski-b87958ef3e211f4f3cf6906a3108e031.jpg";